import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  // Check for a "guest mode" flag in session storage
  const isGuestMode = sessionStorage.getItem('guestMode') === 'true';
  
  if (loading) {
    return <div>Loading...</div>;
  }
  
  // Allow access if user is authenticated OR in guest mode
  if (user || isGuestMode) {
    return children;
  }
  
  // Redirect to login if not authenticated and not in guest mode
  return <Navigate to="/login" replace />;
};

export default ProtectedRoute;